import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { tap, switchMap, take } from 'rxjs/operators';
import { selectIsCallCenter } from '@store/selectors/is-call-center.selector';
import { ResetIsCallCenter } from '@store/actions/is-call-center.actions';
import { TenantService } from '@lib/services/tenant.service';
import { Store } from '@ngrx/store';
import { clearTenantKey } from '@store/actions/tenant.actions';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
    const router = inject(Router);
    const activatedRoute = inject(ActivatedRoute);
    const dialog = inject(MatDialog);
    const tenantService = inject(TenantService);
    const store = inject(Store);
    const tenantKey = tenantService.getTenantKey() || '';
    const accessToken = localStorage.getItem('accessToken') || '';
    const customToken = localStorage.getItem('customToken') || '';
    const xConsumerUsername = activatedRoute.snapshot.firstChild?.paramMap.get('tenant') || '';
    return store.select(selectIsCallCenter).pipe(
        take(1),
        switchMap((callCenter) => {
            if (!accessToken && !callCenter) {
                request = request.clone({ headers: request.headers.set('X-Consumer-Username', xConsumerUsername) });
                if (!request.headers.get('x-no-authorization')) {
                    request = request.clone({ headers: request.headers.set('Authorization', `${customToken}`) });
                }
            }
            if (accessToken && !request.headers.get('x-no-authorization')) {
                request = request.clone({ headers: request.headers.set('Authorization', `Bearer ${accessToken}`) });
            }

            if (request.headers.has('x-no-authorization')) {
                request = request.clone({ headers: request.headers.delete('x-no-authorization') });
            }

            return next(request).pipe(
                tap({
                    error: ({ status, ...err }) => {
                        if (status === 401 || (status === 403 && !accessToken)) {
                            router.navigateByUrl(`auth/${tenantKey}/login`).then(() => {
                                store.dispatch(clearTenantKey());
                                // Prevent subsequent API calls by completing the observable
                                throw new Error('Redirected to login');
                            });
                            dialog.closeAll();
                            localStorage.removeItem('accessToken');
                            localStorage.removeItem('selectedUser');
                            localStorage.removeItem('customToken');
                            store.dispatch(new ResetIsCallCenter());
                        }
                    },
                }),
            );
        }),
    );
};
